import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { Observable, of } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class WebApiEditorGuard implements CanActivate {
  constructor(
    private abcConfigService: AbcConfigService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.abcConfigService.configuration?.WebApi?.AllowBaseURLChange) {
      return of(this.userService.createLoginPageUrlTree(this.router, this.route));
    } else {
      return of(true);
    }
  }
}
